module.exports = __webpack_public_path__ + "static/media/u-form.6756de63.svg";